import type {
  WorkflowMetadata,
  WorkflowSummary,
  WorkflowWithData,
} from '../../api/types';

export type StartChooserState = {
  activeView: 'builder';
  selectedWorkflowId: undefined;
  workflow: undefined;
  showTemplateChooser: true;
};

export function openWorkflowStartChooser({
  disconnectOverviewSockets,
  loadTemplates,
  teardownEditor,
}: {
  disconnectOverviewSockets: () => void;
  loadTemplates: () => Promise<unknown> | unknown;
  teardownEditor?: () => void;
}): StartChooserState {
  teardownEditor?.();
  disconnectOverviewSockets();
  void loadTemplates();
  return {
    activeView: 'builder',
    selectedWorkflowId: undefined,
    workflow: undefined,
    showTemplateChooser: true,
  };
}

export async function createBlankWorkflow({
  workflows,
  createWorkflow,
}: {
  workflows: WorkflowSummary[];
  createWorkflow: () => Promise<WorkflowMetadata>;
}): Promise<{
  workflow: WorkflowMetadata;
  workflows: WorkflowSummary[];
}> {
  const created = await createWorkflow();
  const nextWorkflows = [...workflows, created];
  return {
    workflow: created,
    workflows: nextWorkflows,
  };
}

export async function importWorkflowFile({
  file,
  workflows,
  importWorkflow,
}: {
  file: File;
  workflows: WorkflowSummary[];
  importWorkflow: (file: File) => Promise<WorkflowWithData>;
}): Promise<{
  workflow: WorkflowWithData;
  workflows: WorkflowSummary[];
}> {
  const imported = await importWorkflow(file);
  const nextWorkflows = [...workflows, imported];
  return {
    workflow: imported,
    workflows: nextWorkflows,
  };
}
